import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  showSimilar: false,
};

const listingSlice = createSlice({
  name: 'listing',
  initialState,
  reducers: create => ({
    setShowSimilar: create.reducer((state, {payload}) => ({
      ...state,
      showSimilar: payload,
    })),
  }),
});

export const listingState = state => state.listing;

export const {setShowSimilar} = listingSlice.actions;

export default listingSlice.reducer;
